import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	subtitle: {
		flexGrow: 1,
	},
}));

export default function InfoBar({ firstName, lastName, networth, gender }) {
	const classes = useStyles();

	// creating state
	const [genderEmoji, setGenderEmoji] = useState("");

	useEffect(() => {
		// Setting gender emoji
		if (gender === "MALE") {
			setGenderEmoji("👨");
		} else if (gender === "FEMALE") {
			setGenderEmoji("👩");
		} else {
			setGenderEmoji("😶");
		}
	}, [gender]);

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar position="static" color="secondary">
				<Toolbar variant="dense">
					<Typography variant="subtitle1" className={classes.subtitle}>
						{genderEmoji} {firstName} {lastName}
					</Typography>
					<Typography variant="subtitle2">
						Networth:{" "}
						<strong>{networth < 0 ? "-$" + networth : "$" + networth}</strong>
					</Typography>
				</Toolbar>
			</AppBar>
		</div>
	);
}
